
import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'BackButton'
})
export default class BackButton extends Vue {}
